import React from "react";

const SelectInput = ({
  label,
  value,
  onChange,
  choices,
  error,
  readOnly = false,
}) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <select
        name="category"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={readOnly}
      >
        <option value="">-- Select --</option>
        {choices.map((c, index) => (
          <option value={c.id} key={index}>
            {c.name}
          </option>
        ))}
      </select>
      {error && <p className="error-text">{error}</p>}
    </div>
  );
};

export default SelectInput;
